@if (lagerplatz(); as lagerplatz) {
  <div
    class="soft-card border p-6 rounded"
    [ngClass]="hideScan() ? 'h-full border-primary' : 'mt-1'"
  >
    <div
      class="flex flex-col xs:flex-row xs:justify-between flex-nowrap"
      [ngClass]="
        hideScan()
          ? 'h-full items-center justify-center xs:flex-row xs:justify-center'
          : ''
      "
    >
      <div
        class="flex flex-col justify-center items-center"
        [ngClass]="{ 'cursor-pointer hover:underline': canSelect() }"
        (click)="onOpenSelect()"
      >
        <span class="text-lg font-semibold">{{ lagerplatz.lagerplatz }}</span>
      </div>
      @if (canScan() && !hideScan()) {
        <div class="flex flex-col justify-center align-middle items-center">
          <button class="soft-button primary rounded-full" (click)="onScan()">
            <i class="fa-regular fa-barcode-scan mr-2"></i>
            {{ '#KOMMISSIONIERUNG.PAGES.ARTIKEL_MENGE.CHANGE' | translate }}
          </button>
        </div>
      }
    </div>
  </div>
} @else {
  <div
    class="flex flex-col md:flex-row flex-nowrap md:justify-between gap-2"
    [ngClass]="hideScan() ? 'h-full' : ''"
  >
    @if (canScan() && !hideScan()) {
      <div class="flex w-full">
        <soft-scan-button></soft-scan-button>
      </div>
    }
    @if (canSelect()) {
      <button
        [ngClass]="hideScan() ? 'h-full' : ''"
        class="bg-surface border border-solid border-primary rounded px-4 py-2 cursor-pointer shadow text-left w-full hover:bg-hover"
        (click)="onOpenSelect()"
      >
        <div class="flex flex-row">
          <div class="flex items-center align-middle">
            <i class="fa-regular fa-shelves fa-2x"></i>
          </div>
          <div class="flex flex-col ml-4" [ngClass]="hideScan() ? 'hidden lg:flex' : ''">
            <div class="font-semibold text-lg">
              {{ '#LAGERPLATZ_CORE.COMPONENTS.LAGERPLATZ_SUCHE.TITLE' | translate }}
            </div>

            @if (!hideScan()) {
              <div class="text-sm color-light">
                {{
                  '#LAGERPLATZ_CORE.COMPONENTS.LAGERPLATZ_SUCHE.DESCRIPTION' | translate
                }}
              </div>
            }
          </div>
        </div>
      </button>
    }
  </div>
}
